import { Component, OnInit, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ErrorStateMatcher } from '@angular/material/core';
import {
  FormGroup
  , FormControl
  , Validators
  , AbstractControl
  , ValidationErrors
  , FormBuilder
  , NgForm
  , FormGroupDirective
  , FormArray
} from '@angular/forms';
import { ApiService } from '../../services/api.service';
import { FormValidatorService } from '../../shared/form_Validation/form-validator.service';
import { from } from 'rxjs';
import { NgxSpinnerService } from 'ngx-spinner';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
@Component({
  selector: 'app-login-details',
  templateUrl: './login-details.component.html',
  styleUrls: ['./login-details.component.css']
})
export class LoginDetailsComponent implements OnInit {
  userData = <any>[];
  businessLicenseList = <any>[];
  businessEntityList = <any>[];
  entit = <any>'';
  licensetype = <any>'';
  stateList = <any>[];
  state = <any>'';
  constructor(private route: ActivatedRoute, private router: Router, private dialog: MatDialog,
    private Register: ApiService
    , private Formvalidator: FormValidatorService
    , private formBuilder: FormBuilder
    , private spinner: NgxSpinnerService, ) {

  }
  getBusinessLicenseDetails() {
    this.Register.functionGET('business/license_type', {}).subscribe((res) => {
      this.businessLicenseList = res['data'];
      
      this.MAP_LIcense(this.userData.userData.bp_businesses[0].bp_license_type_id);

    },
      err => {
        
      });
  }


  ngOnInit() {
    
    this.getBusinessLicenseDetails();
    this.getBusinessEntityDetails();
    this.getAllStates();
  }


  MAP_LIcense(id) {
    
    this.businessLicenseList.map((x) => {
      
      if (id === x.bp_license_type_id) {
        if (x.name === 'Other') {
          this.licensetype = this.userData.userData.bp_businesses[0].bp_license_type_comment;
          
        } else {
          this.licensetype = x.name;
        }
      }
    });
    
  }


  MAP_Entity(id) {
    
    this.businessEntityList.map((x) => {
      
      if (id === x.bp_entity_type_id) {
        this.entit = x.name;
      }
    });
    
  }

  MAP_State(id) {
    
    this.stateList.map((x) => {
      
      if (id === x.bt_region_id) {
        this.state = x.name;
      }
    });
    
  }


  getBusinessEntityDetails() {
    this.Register.functionGET('business/entity_type', {}).subscribe((res) => {
      this.businessEntityList = res['data'];
      this.MAP_Entity(this.userData.userData.bp_businesses[0].bp_entity_type_id);
    },
      err => {
        
      });
  }


  getAllStates() {
    this.Register.functionGET('country/allStates', {}).subscribe((res) => {
      this.stateList = res['data'];
      this.MAP_State(this.userData.userData.bp_businesses[0].bp_license_state_bt_region_id);
    },
      err => {
      });
  }


}
